import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { NgxChartsModule, PieChartModule } from '@swimlane/ngx-charts';
import { MatSelectModule, MAT_CHECKBOX_CLICK_ACTION, MatRadioButton, MatRadioModule, MatDialogModule } from '@angular/material';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AddLoginComponent } from './add-login.component';
import { RouterModule, Routes } from '@angular/router';
import { AddLoginRoutingModule } from './add-login-routing.module';

@NgModule({
    declarations: [AddLoginComponent],
    imports: [
        CommonModule,
        NgbModule,
        MatchHeightModule,
        NgxChartsModule,
        PieChartModule,
        MatSelectModule,
        SharedModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatDialogModule,
        AddLoginRoutingModule

    ],
    exports: [RouterModule, AddLoginComponent],
})
export class AddLoginModule { }